module.exports = __webpack_public_path__ + "media/images/circleWithCheck-841ca24b20285ce9b385258c2d5b76cd.svg";